"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depthVariant = exports.radiusVariant = exports.paperTheme = void 0;
const component_theme_1 = require("@clds/component-theme");
const { palette, radius, shadow, spacing } = component_theme_1.globalTheme;
exports.paperTheme = (0, component_theme_1.createTheme)({
    background: palette.surface,
    radiusVariant: {
        sm: {
            radius: radius.unstable_new.sm,
            padding: spacing.sm,
        },
        md: {
            radius: radius.unstable_new.md,
            padding: spacing.sm,
        },
        lg: {
            radius: radius.unstable_new.lg,
            padding: spacing.sm,
        },
        xl: {
            radius: radius.unstable_new.xl,
            padding: spacing.lg,
        },
    },
    depthVariant: {
        none: {
            shadow: 'none',
        },
        sm: {
            shadow: shadow.sm,
        },
        md: {
            shadow: shadow.md,
        },
        lg: {
            shadow: shadow.lg,
        },
    },
}, 'paper');
exports.radiusVariant = (0, component_theme_1.createVariant)(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => exports.paperTheme.radiusVariant[props.borderRadius || 'md']);
exports.depthVariant = (0, component_theme_1.createVariant)(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => exports.paperTheme.depthVariant[props.depth || 'md']);
//# sourceMappingURL=theme.js.map